const SampleReceiveLabelIndex = () => import("@/pages/lab/sample/SampleReceiveLabelIndex");
const SampleSingle = () => import("@/pages/lab/sample/SampleSingle");
const SampleReceiveNest = () => import("@/pages/lab/sample/SampleReceiveNest");
const SampleResultsNest = () => import("@/pages/lab/sample/SampleResultsNest");
const SampleIndex = () => import("@/pages/lab/sample/SampleIndex");
const SampleDetail = () => import("@/pages/lab/sample/SampleDetail");
const SampleAdd = () => import("@/pages/lab/sample/SampleAdd");
const SampleEdit = () => import("@/pages/lab/sample/SampleEdit");
const SamplePrep = () => import("@/pages/lab/sample/SamplePrep");
const SampleNote = () => import("@/pages/lab/sample/SampleNote");
const SampleAuditTrail = () => import("@/pages/lab/sample/SampleAuditTrail");
const SampleAuditTrailHistory = () => import("@/pages/lab/sample/SampleAuditTrailHistory");
const SampleResultAdd = () => import("@/pages/lab/sample/SampleResultAdd");
const SampleResultEdit = () => import("@/pages/lab/sample/SampleResultEdit");
const ReceiveIndex = () => import("@/pages/lab/sample/ReceiveIndex");
const ReceiveDetail = () => import("@/pages/lab/sample/ReceiveDetail");
const ReceiveBatch = () => import("@/pages/lab/sample/ReceiveBatch");
const ReceiveBatchPrint = () => import("@/pages/lab/sample/ReceiveBatchPrint");
const ReceiveScan = () => import("@/pages/lab/sample/ReceiveBatchScan");
const SampleApplyTestPackage = () => import("@/pages/lab/sample/SampleApplyTestPackage");

export class SampleRoutes {
  constructor() {
    this.route_root = "samples";
    this.type_single = "Sample";
    this.type_plural = "Samples";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            component: SampleIndex,
            meta: { requiresAuth: true },
          },
          {
            path: "add",
            component: { render (c) { return c('router-view') } },
            children: [
              {
                path: "",
                name: `Add ${this.type_single}`,
                component: SampleAdd,
                meta: { requiresAuth: true },
              },
              {
                path: ":submission_id",
                name: `Add ${this.type_single}`,
                component: SampleAdd,
                meta: { requiresAuth: true },
              }
            ]
          },
          {
            path: "receive",
            component: SampleReceiveNest,
            children: [
              {
                path: "",
                name: `Receive ${this.type_plural}`,
                component: ReceiveIndex,
                meta: { requiresAuth: true },
              },
              {
                path: "batch",
                component: SampleReceiveNest,
                meta: { requiresAuth: true },
                children: [
                  {
                    path: "",
                    name: `Receive ${this.type_plural} Batch`,
                    component: ReceiveBatch,
                  },
                  {
                    path: "print",
                    name: `Receive ${this.type_plural} Print`,
                    component: ReceiveBatchPrint,
                    meta: { requiresAuth: true },
                    props: true,
                  },
                  {
                    path: "scan",
                    name: `Receive ${this.type_plural} Scan`,
                    component: ReceiveScan,
                    meta: { requiresAuth: true },
                  }
                ]
              },
              {
                path: ":project_id",
                name: `Receive ${this.type_single}`,
                component: ReceiveDetail,
                meta: { requiresAuth: true },
              },
            ],
          },
          {
            path: "prep",
            name: `Prep ${this.type_plural}`,
            component: SamplePrep,
            meta: { requiresAuth: true },
          },
          {
            path: ":sample_id",
            component: SampleSingle,
            children: [
              {
                path: "",
                component: SampleDetail,
                name: this.type_single,
                meta: { requiresAuth: true },
              },
              {
                path: "label",
                name: `${this.type_single} Label`,
                component: SampleReceiveLabelIndex,
                meta: { requiresAuth: true },
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: SampleEdit,
                meta: { requiresAuth: true },
              },
              {
                path: "note",
                name: `${this.type_single} Note`,
                component: SampleNote,
                meta: { requiresAuth: true },
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: SampleAuditTrail,
                meta: { requiresAuth: true },
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: SampleAuditTrailHistory,
                meta: { requiresAuth: true },
              },
              {
                path: "apply-test-package",
                name: `Apply Test Package`,
                component: SampleApplyTestPackage,
                meta: { requiresAuth: true },
              },
              {
                path: "results",
                component: SampleResultsNest,
                children: [
                  {
                    path: "add",
                    name: `New ${this.type_single} result`,
                    component: SampleResultAdd,
                    meta: { requiresAuth: true },
                  },
                  {
                    path: "edit",
                    name: `Manage Sample Results`,
                    component: SampleResultEdit,
                    meta: { requiresAuth: true },
                  },
                ],
              },
            ],
          },
        ],
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
